import React from 'react'
import MaterialSymbol from '../material-symbol'

const SwapVert = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="swap_vert" {...props} />
))

SwapVert.displayName = 'SwapVert'

export default SwapVert
